import React, {Component} from 'react'
import TableComp from '../../../components/_utils/table'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {RightsWrapper} from '../../../components/_utils/utils'
import _ from 'lodash';
import moment from 'moment'
import {Button, Card, Row, Col, notification, Popconfirm, Tooltip} from 'antd'
import Request from '../../../request'

import { Link } from "react-router-dom";

import {connect} from 'react-redux'
import styles from './styles.less'
import {getUrlPushWrapper} from '../../../routes'
import commonStyle from '../../common.less'

class AllKnowledgeBase extends Component {
    state = {count: 0, arr: [], list: [], loadList: false, allCountries:[], allCategories:[]}

    constructor(props) {
        super(props)

        this.table = React.createRef()
    }

    apiRequest = params => {
        
        return new Promise(async resolve => {
        
            if (!params) {
                params = {}
            }
            if (!params.sortField) {
                params.sortField = '_id'
                params.sortOrder = 'descend'
            }
        
            let data = await Request.loadKnowledgeBase({
                ...params,
                regExFilters: ['universityInstitutionName']
            })
            this.setState({count: data.total})
            resolve(data)
        })
    }

    handleDelete = (knowledgeBaseId) => {
        Request.deleteKnowledgeBase({_id: knowledgeBaseId})
            .then(x => {

                if (x.success) {
                    notification.success({
                        message: x.msg,
                        description: x.msg
                    })
                } else {
                    notification.error({
                        message: 'Error',
                        description: x.msg
                    })
                }
                this.table.current.reload()
            })
            .catch(err => {
                notification.error({
                    message: 'Error',
                    description: 'Some Error'
                })
            })
    }

    loadUniversities = async() =>{
        let params = {
            results:10000,
            count:10000
        }
        let response = await Request.getUniversities(params)
        console.log(response)
    }

    loadCountries = async() =>{
        let params = {
            results:10000,
            count:10000
        }
        let response = await Request.getCountries(params)
        let allCountries = []
        _.each(response.data, (country)=>{
            allCountries.push({value:country._id, text:country.countryName})
        })
        this.setState({allCountries})
    }

    loadKnowledgeBaseCategories = async() =>{
        let params = {
            results:10000,
            count:10000
        }
        let response = await Request.loadKnowledgeBaseCategory(params)
        let allCategories = []
        _.each(response.data, (category)=>{
            allCategories.push({value:category._id, text:category.name})
        })
        this.setState({allCategories})
    }


    async componentDidMount() {
        this.loadCountries()
        this.loadUniversities()
        this.loadKnowledgeBaseCategories()
    }

    render() {
        const {dispatch} = this.props

        const columns = [
            {
                title: 'Country Name',
                key: 'countryId',
                dataIndex: 'countryId.countryName',
                filters:this.state.allCountries,
                sorter: true,
                filterRegex: true
            },
            {
                title: 'University Name',
                key: 'universityInstitutionName',
                dataIndex: 'universityId.universityInstitutionName',
                searchTextName: 'name',
                filterRegex: true,
                // showSearch:'Search University',
                // sorter: true,
                // filterRegex: true
            },
            {
                title: 'KnowledgeBase Category Name',
                key: 'knowledgeBaseCategoryId',
                dataIndex: 'knowledgeBaseCategoryId.name',
                filters:this.state.allCategories,
                sorter: true,
                filterRegex: true
            },

            {
                title: 'Last Updated By',
                key: 'lastUpdatedByName',
                dataIndex: 'lastUpdatedByName',
                render: (text, record) => {
                    return (
                        <div>
                            <div
                                className={commonStyle.user}>{record.updatedByUser ? record.updatedByUser.name : record.createdByUser.name}</div>
                            <div>
                            {record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}
                            </div>
                        </div>
                    )
                }
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => (
                    <React.Fragment>
                        <RightsWrapper myRight={'KnowledgeBase.edit'}>
                            <Tooltip title="Edit Details">
                                <Button
                                    className={styles.btn}
                                    shape="circle"
                                    onClick={() => {
                                        dispatch(
                                            getUrlPushWrapper('knowledge-base.edit-knowledge-base', {id: record._id})
                                        )
                                    }}
                                    icon="edit"
                                />
                            </Tooltip>
                        </RightsWrapper>
                        <RightsWrapper myRight={'KnowledgeBase.delete'}>
                            <Tooltip title="Delete Knowledge Base">
                                <Popconfirm
                                    title="Are you sure to delete Knowledge Base?"
                                    onConfirm={() => this.handleDelete(record._id)}
                                    okText="Yes"
                                    cancelText="No">
                                    <Button
                                        shape="circle"
                                        className={styles.btn}
                                        icon="delete"/>
                                </Popconfirm>
                            </Tooltip>
                        </RightsWrapper>
                    </React.Fragment>
                )
            }
        ]
        return (
            <PageHeaderWrapper title={`Knowledge Base : ${this.state.count} `}>
                <Card bordered={true}>
                    <Row>
                        <Col span={22}></Col>
                        <Col span={2}>
                            <div style={{textAlign: 'right', marginTop: '15px'}}>
                                <Link to='/add-knowledge-base'><Button>Add</Button></Link>
                            </div>
                        </Col>
                    </Row>
                    <TableComp
                        columns={columns}
                        apiRequest={this.apiRequest}
                        ref={this.table}/>
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global}) => ({
    categories: global.categories
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AllKnowledgeBase)
